import classnames from 'classnames';
import EyeIcon from 'components/icons/EyeIcon';
import React, { Component } from 'react';

const CSS = require('./PasswordInput.module.scss');

interface PasswordInputProps {
  handleChange: (e: any) => void;
  value: string;
  className?: string;
  autoComplete?: string;
  placeholder?: string;
}

interface PasswordInputState {
  passwordVisible: boolean;
}

class PasswordInput extends Component<PasswordInputProps, PasswordInputState> {
  state = {
    passwordVisible: false,
  };

  togglePasswordVisibility = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible,
    });
  };

  render() {
    const { autoComplete, handleChange, value, className, ...rest } =
      this.props;
    return (
      <div className={classnames(className, CSS.passwordInput)}>
        <input
          autoComplete={autoComplete}
          className={CSS.input}
          type={this.state.passwordVisible ? 'text' : 'password'}
          value={value}
          name={'password'}
          onChange={handleChange}
          required={true}
          {...rest}
        />
        <button
          type={'button'}
          className={CSS.toggle}
          onClick={this.togglePasswordVisibility}
        >
          <EyeIcon width={20} height={20} />
        </button>
      </div>
    );
  }
}

export default PasswordInput;
